import React from 'react';
import { useSelector } from 'react-redux';

// Segmented Tags/Filenames switcher for the Fix Metadata tab — replaces the
// old underline sub-tabs, which read as plain text and were easy to miss.
// Rendered by BOTH sub-tab tables, so the counts pull straight from the
// fixMetadata slice to stay identical on either side:
//   Tags      = rows with pending tag changes
//   Filenames = rows with a rename suggestion under the current mode
const MetadataSubTabs = ({ activeSubTab, onSubTabChange }) => {
    const { metadataComparisons, filenameMode } = useSelector((state) => state.fixMetadata);
    const tagsCount = metadataComparisons.filter((c) => c.hasChanges).length;
    const mode = filenameMode || 'both';
    const filenamesCount = mode === 'none' ? 0 : metadataComparisons.filter((c) =>
        (c.filenameByMode ? c.filenameByMode[mode] : c.suggestedFilename)
    ).length;

    const seg = (key, label, count) => (
        <button
            key={key}
            className={`metadata-seg-btn ${activeSubTab === key ? 'active' : ''}`}
            onClick={() => onSubTabChange(key)}
        >
            {label}
            {count > 0 && <span className="metadata-seg-count">{count}</span>}
        </button>
    );

    return (
        <div className="metadata-seg-tabs">
            {seg('tags', 'Tags', tagsCount)}
            {seg('filenames', 'Filenames', filenamesCount)}
        </div>
    );
};

export default MetadataSubTabs;
